module.exports = __webpack_public_path__ + "static/media/alert_round.a6833873.png";